import common from './common';
import fieldValidation from './fieldValidation';
import invoiceManagement from './invoiceManagement';

const zhCn = { common, invoiceManagement, fieldValidation };
export default zhCn;
